import {
    Container,
    Image,
    Flex,
    Text,
    Grid,
    Center,
    Title,
    Stack,
    Button,
    MantineProvider,
    AspectRatio,
    Box,
    rem,
    Group,
} from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { useEffect, useState } from "react";

import React from "react";
import { Link, useParams } from "react-router-dom";

<style>
    @import
    url('https://fonts.googleapis.com/css2?family=Abril+Fatface&family=PT+Sans&display=swap');
</style>;

/**
 * This view component will be rendered when visiting /pages/greet
 * when your application has been setup with inertiajs.
 */
export default function Thanks() {
    const [tour, setTour] = useState(null);
    const params = useParams();
    console.log(params);
    useEffect(() => {
        fetch("/tours/get/" + params.tour_id)
            .then((res) => res.json())
            .then(
                (result) => {
                    setTour(result);
                    console.log(result);
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {}
            );
    }, []);
    const { height, width } = useViewportSize();
    return (
        // <Container size="responsive" h={"100vh"} p={0}>
        //     <Image
        //         radius="none"
        //         style={{ height: "100vh" }}
        //         src="https://www.best-scottish-tours.co.uk/Plugin/ImageSlider/assets/xlarge_X69LFZ.jpg"
        //         alt="Random unsplash image"
        //     />
        // </Container>
        <MantineProvider
            theme={{
                fontFamily: "PT Sans,Abril Fatface,  sans-serif",
                fontSizes: {
                    xs: rem(10),
                    sm: rem(11),
                    md: rem(14),
                    lg: rem(14),
                    xl: rem(40),
                },
                headings: {
                    fontFamily: "Abril Fatface,PT Sans, sans-serif",
                },
            }}
        >
            <Grid h={height} className="intro background-tint" p={0}>
                <Grid.Col span={{ base: 12, md: 12 }} h={height}>
                    <Center>
                        <Stack
                            align="center"
                            style={{ color: "white" }}
                            justify="center"
                            h={height}
                            mt={70}
                            w={700}
                        >
                            <Title
                                style={{
                                    textAlign: "center",
                                    fontSize: "3rem",
                                    lineHeight: "1",
                                }}
                                order={1}
                            >
                                Thank you for confirming
                            </Title>
                            <Text size="xl">
                                A Tour Coordinator will be in touch
                            </Text>
                            <Image
                                src="/img/BST-logo-colour_1.png"
                                w={"80%"}
                            ></Image>
                        </Stack>
                    </Center>
                </Grid.Col>
            </Grid>
        </MantineProvider>
    );
}
